module.exports = __webpack_public_path__ + "img/pic_tltw_sczp@2x.2dae27a8.png";